export default __webpack_public_path__ + "static/media/welcome-back.42d0a4ed.svg";